export const getTableFields = (state, tabID) => state.ui.tabs[tabID].tableFields;
